import {
    IFRInviteeData,
    IRewardsResponseItem,
    IRewardsResponseList
} from '@sitegen/common/classes/friends-referral-api';
import { IProgressBarStep } from './progress-block-bar';
import TEXT_KEYS, {
    REWARD_TIERS_MOBILE_NUMBER,
    REWARD_TIERS_NUMBER
} from './progress-block.constants';
import { TranslationFunction } from 'i18next';

export const getConvertedFriendsCount = (invitees: IFRInviteeData[]): number => {
    return invitees.filter(({ isConverted }) => isConverted).length;
};

export const getStepFromReward = (
    reward: IRewardsResponseItem,
    translateKey: TranslationFunction
): IProgressBarStep => {
    const { levelLimit } = reward;
    const title = levelLimit === 1
        ? translateKey(TEXT_KEYS.ONE_FRIEND)
        : translateKey(TEXT_KEYS.PLURAL_FRIENDS, { amount: levelLimit });

    return { title, count: levelLimit };
};

export const getSteps = (
    rewardTiers: IRewardsResponseList,
    currentSlide: number,
    translateKey: TranslationFunction
): IProgressBarStep[] => {
    const rewards = Object.values(rewardTiers);
    const res: IProgressBarStep[] = [];

    for (let i = 0; i < REWARD_TIERS_NUMBER; ++i) {
        const currentReward: undefined | IRewardsResponseItem = rewards[i + currentSlide];
        if (currentReward) {
            res.push(getStepFromReward(currentReward, translateKey));
        }
    }

    return res;
};

export const getMobileSteps = (
    rewardTiers: IRewardsResponseList,
    expandButtonOpened: boolean,
    translateKey: TranslationFunction
): IProgressBarStep[] => {
    const allSteps = Object.values(rewardTiers)
        .map((value) => getStepFromReward(value, translateKey));

    return expandButtonOpened
        ? allSteps
        : allSteps.filter((_, index) => index < REWARD_TIERS_MOBILE_NUMBER);
};


export const canSlidePrev = (currentSlide: number): boolean => {
    return currentSlide > 0;
};

export const canSlideNext = (rewardTiers: IRewardsResponseList, currentSlide: number): boolean => {
    const alreadyShowed = REWARD_TIERS_NUMBER + currentSlide;
    return alreadyShowed < Object.keys(rewardTiers).length;
};
